import {Observable} from 'rxjs';
import i18next from 'i18next';

import {combineEpics} from 'web-app/util/redux-observable';
import InboxApi from 'web-app/api/inbox-api';
import * as GlobalEventActions from 'web-app/react/global-event/actions';
import * as FileActions from 'web-app/react/components/file-upload/actions';

import * as Constants from './constants';
import * as Actions from './actions';

const send = action$ =>
    action$.ofType(Actions.send.type).mergeMap(({payload}) =>
        InboxApi.sendNewMessageObservable(payload.body, payload.participants, payload.imageIds, payload.fileIds)
            .flatMap(response => [
                FileActions.clearFiles(Constants.FORM_NAME),
                Actions.sendSuccess.action(response),
                GlobalEventActions.updateSuccess.action(i18next.t('messages.messageSent')),
            ])
            .catch(e => Observable.of(Actions.sendFailed.action(e))),
    );

export default combineEpics(send);
